import React from "react";

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode;
  /** @deprecated pass children instead */
  label?: React.ReactNode;
  prefixIcon?: React.ReactNode;
  suffixIcon?: React.ReactNode;
  /** @deprecated ignored, use className instead */
  size?: string;
}

export default function SecondaryButton({ children, label, prefixIcon, suffixIcon, size: _size, className = "", ...rest }: Props) {
  return (
    <button
      type="button"
      className={`inline-flex items-center justify-center gap-2 bg-zinc-100 text-zinc-700 font-medium text-sm px-4 py-2 rounded-xl hover:bg-zinc-200 transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
      {...rest}
    >
      {prefixIcon}
      {children ?? label}
      {suffixIcon}
    </button>
  );
}
